import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const BreadcrumbNavigation = () => {
  return (
    <nav className="bg-surface/30 border-b border-border-light py-4">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <ol className="flex items-center space-x-2 text-sm">
          <li>
            <Link
              to="/"
              className="text-text-secondary hover:text-primary transition-colors duration-200 flex items-center space-x-1"
            >
              <Icon name="Home" size={16} />
              <span>Home</span>
            </Link>
          </li>
          <li className="text-text-secondary">
            <Icon name="ChevronRight" size={16} />
          </li>
          <li>
            <Link
              to="/practice-areas-overview"
              className="text-text-secondary hover:text-primary transition-colors duration-200"
            >
              Practice Areas
            </Link>
          </li>
          <li className="text-text-secondary">
            <Icon name="ChevronRight" size={16} />
          </li>
          <li className="text-text-primary font-medium">
            Employment & Labor Law
          </li>
        </ol>
      </div>
    </nav>
  );
};

export default BreadcrumbNavigation;